import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import md5 from 'md5';
import header from '../../assets/icm-header.jpg';
import icp from '../../assets/icp-brasil.png';
import {
  getBase64PDFImage,
  getBase64PDFImagePNG,
  prefixo,
  scaleStyles,
  baseStyles,
} from '../../util/utils';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

// TODO: melhorar isso. pra que todos eses paramentos?
export default async function generateRequisicaoPDF(
  requisicao,
  tipo = 'imprimirNormal',
  fontScale = 1.0,
  qrcodeBase64,
  codFunc,
  assinaturaDigital,
  isDoctorLoggedIn
) {
  const styles = scaleStyles(baseStyles, fontScale);

  const headerImage =
    tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
      ? await getBase64PDFImage(header)
      : null;
  const icpLogoBase64 = await getBase64PDFImagePNG(icp);

  const now = new Date();
  const dataHora = now
    .toLocaleString('pt-BR', { hour12: false })
    .replace(',', '');

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: headerImage ? [40, 140, 20, 130] : [40, 120, 20, 160],
    header: headerImage
      ? {
          image: headerImage,
          width: 500,
          alignment: 'center',
          margin: [0, 10, 0, 0],
        }
      : undefined,
    content: [
      {
        text:
          tipo === 'imprimirTimbrado' || tipo === 'envioWpp'
            ? 'REQUISIÇÃO DE EXAMES'
            : '',
        style: 'title',
        alignment: 'center',
        margin: [0, 0, 0, 0],
      },
      {
        text: requisicao.descricao ? requisicao.descricao : ' ',
        style: 'files',
        margin: [100, 10, 0, 10],
      },
    ],
    footer: function footer(currentPage, pageCount) {
      return {
        margin: [40, 0, 40, 0],
        stack: [
          {
            table: {
              widths: [50, '*', '*', 80],
              body: [
                [
                  assinaturaDigital
                    ? {
                        image: icpLogoBase64,
                        width: 80,
                        alignment: 'left',
                        rowSpan: 1,
                        border: [false, false, false, false],
                      }
                    : {
                        width: 80,
                        text: '',
                        border: [false, false, false, false],
                      },
                  {
                    colSpan: 2,
                    stack: [
                      ...(isDoctorLoggedIn
                        ? [
                            {
                              text: assinaturaDigital
                                ? 'Documento assinado digitalmente'
                                : 'Documento assinado eletronicamente',
                              alignment: 'center',
                              bold: true,
                              margin: [0, 0, 0, 0],
                            },
                            {
                              text: `Autenticação: ${md5(
                                JSON.stringify(requisicao || '')
                              )}`,
                              alignment: 'center',
                              style: 'smaller',
                              margin: [0, 0, 0, 2],
                            },
                          ]
                        : []),
                      {
                        text: `Médico: ${prefixo(
                          requisicao
                        )} ${requisicao.nomeMedico || ''}`,
                        alignment: 'center',
                        margin: [0, 0, 0, 0],
                      },
                      {
                        text: `CRM: ${requisicao.crm || ''}${
                          requisicao.rqe ? ' - RQE: ' + requisicao.rqe : ''
                        }`,
                        alignment: 'center',
                        margin: [0, 0, 0, 2],
                      },
                      ...(isDoctorLoggedIn
                        ? [
                            {
                              text: assinaturaDigital
                                ? '* A assinatura digital deste documento poderá ser verificada em https://validar.iti.gov.br/ *'
                                : '* VALIDAÇÃO: Aponte a câmera do celular usando o QRCode ao lado *',
                              alignment: 'center',
                              style: 'smaller',
                              margin: [0, 0, 0, 0],
                            },
                            {
                              text: `* REQUISIÇÃO: ${requisicao.codRequisicao ||
                                ''} - PACIENTE: ${requisicao.codPaciente ||
                                ''} *`,
                              alignment: 'center',
                              style: 'smaller',
                              margin: [0, 0, 0, 0],
                            },
                          ]
                        : []),
                      {
                        text: `Emitida por ${codFunc || ''} em ${dataHora}`,
                        alignment: 'center',
                        style: 'smaller',
                        margin: [0, 0, 0, 0],
                      },
                      {
                        text: `Página ${currentPage} de ${pageCount}`,
                        alignment: 'center',
                        style: 'smaller',
                        margin: [0, 0, 0, 0],
                      },
                    ],
                    style: 'content',
                    border: [false, false, false, false],
                  },
                  {},
                  // Coluna 4: QRCode
                  ...(isDoctorLoggedIn
                    ? [
                        qrcodeBase64
                          ? {
                              image: qrcodeBase64,
                              width: 70,
                              alignment: 'right',
                              border: [false, false, false, false],
                            }
                          : {
                              width: 70,
                              text: '',
                              border: [false, false, false, false],
                            },
                      ]
                    : []),
                ],
              ],
            },
            layout: {
              hLineWidth: () => 0,
              vLineWidth: () => 0,
            },
          },
        ],
      };
    },
    styles,
  };

  if (tipo === 'imprimirNormal' || tipo === 'imprimirTimbrado') {
    pdfMake.createPdf(docDefinition).open();
  }
  // Para envio por WhatsApp ou outras integrações, basta retornar o PDF para uso externo
  return pdfMake.createPdf(docDefinition);
}
